import { render, staticRenderFns } from "./quesSimpleViewInfo.vue?vue&type=template&id=65451881"
import script from "./quesSimpleViewInfo.vue?vue&type=script&lang=js"
export * from "./quesSimpleViewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports